<template>
    <div class="container">
        <div>
            <h3>Change password</h3>
        </div>

        <template v-if="changePassword.info" >
            <feedback :info="changePassword.info"></feedback>
            <router-link to="/login">login</router-link>
        </template>

        <template v-else>

            <feedback :error="changePassword.error"/>

            <div class="form-group">
                <label>New Password</label>
                <input class="form-control" type="password"
                       v-bind:class="{'is-invalid': changePassword.fieldErrors.newPassword}"
                       v-bind:value="changePassword.newPassword"
                       @input="onChange"
                       name="newPassword">
                <div class="invalid-feedback" v-if="changePassword.fieldErrors.newPassword">
                    {{changePassword.fieldErrors.newPassword}}
                </div>
            </div>
            <div class="form-group">
                <label>Confirm New Password</label>
                <input class="form-control" type="password"
                       v-bind:class="{'is-invalid': changePassword.fieldErrors.confirmNewPassword}"
                       v-bind:value="changePassword.confirmNewPassword"
                       @input="onChange"
                       name="confirmNewPassword">
                <div class="invalid-feedback" v-if="changePassword.fieldErrors.confirmNewPassword">
                    {{changePassword.fieldErrors.confirmNewPassword}}
                </div>
            </div>

            <div class="form-group">
                <button type="button"
                        v-on:click="submit" v-if="!changePassword.submitting"
                        class="btn btn-primary">Submit</button>
            </div>
        </template>
    </div>
</template>

<script>

    import Feedback from "../commons/feedback";
    import {mapState, mapActions} from "vuex";

    export default {
        name: "change-password",
        components: {
            Feedback
        },
        computed: {
            ...mapState({
                changePassword: state => state.changePassword,
            }),
            base64Email() {
                return this.$route.params.base64Email;
            }
        },
        methods: {
            ...mapActions({
                submitChangePassword: "changePassword",
                changePasswordOnChange: "changePasswordOnChange",
                validate: "changePasswordOnValidate",
                resetFields:"changePasswordResetFields"
            }),
            onChange(event) {
                this.changePasswordOnChange({name: event.target.name, value: event.target.value});
            },
            submit() {
                this.changePasswordOnChange({name: "base64Email", value: this.base64Email});
                this.validate();
                if(this.changePassword.error){
                    return;
                }

                this.submitChangePassword();
            }
        },
        mounted() {
            this.resetFields();
        }
    }
</script>

<style scoped>

</style>
